import { useTheme } from "@emotion/react";
import { FormControlLabel, FormGroup, Grid, IconButton, Paper, Checkbox, Typography, Select, MenuItem, Divider, Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import { WHITEBG } from "ui-components/CustomButton";
import { Primary, Secondary } from 'ui-components/Buttons';
import { FieldArray, FormikProvider, useFormik } from "formik";
import CustomInputField from "ui-components/CustomInputField";
import CustomValidationText from "ui-components/CustomValidationText";
import { ReactComponent as AddIcon } from "assets/rounds_icons/plus_icon.svg";
import PerfectScrollbar from 'react-perfect-scrollbar';
import { capitalizedSentence, containerRef, handleFormSubmit } from "utils/index";
import { ReactComponent as DeleteIcon } from "assets/rounds_icons/delete_icon.svg";
import * as Yup from "yup";
import ModalComponent from "ui-components/ModalComponent";
import Cookies from "js-cookie";


const SetConfigurationsPopup = ({ handleClose, handleSubmit, configurationData, savedConfigurationData, isLoading = false }) => {
  // console.log(configurationData,"configurationData",savedConfigurationData,savedConfigurationData)
  const theme = useTheme();
  let [startup_id, setStartupID] = React.useState(Cookies.get("startup_id") || null);
  // const [configurations, setConfigurations] = useState(configurationData)
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [showCustomTemplate, setShowCustomTemplate] = useState(false)

  const validationObj = {
    currency_type: Yup.string().required("Currency is required").test("no-char-value-only-numbers", "Currency is required", (value) => {
      return value != "select_currency_type"
    }),
    selected_template: Yup.array().of(Yup.object().shape(
      { keySlug: Yup.string().required("Key name is required"), unit: Yup.string().required("Unit is required") },
    )).required("Please select key").min(1, "Please select key"),
  }

  const validationSchema = Yup.object({ ...validationObj });
  let mandatoryFields = !isLoading ? configurationData?.flatMap(item => item?.metrics)?.filter(item => item?.mandatory === "true")?.map(item => item?.keySlug) : []

  const groupedData = !isLoading ? savedConfigurationData?.data?.reduce((acc, item) => {
    acc[item.categoryName] = acc[item.categoryName] || [];
    acc[item.categoryName].push(item);
    return acc;
  }, {}) : {};



  const savedDataFormatted = !isLoading ? Object.keys(groupedData)?.map((key, index) => {
    return ({
      _id: configurationData[index]["_id"],
      categoryName: key,
      metrics: groupedData[key]?.map((metric) => ({
        ...metric,
        defaultUnit: metric.unit,
        value: "",
        mandatory: mandatoryFields?.includes(metric?.keySlug) ? "true" : "false"
      })),
    })
  }) : []

  // console.log(savedDataFormatted, "savedDataFormatted")

  const initialCategories = configurationData?.map((template) => ({
    categoryName: template.categoryName,
    metrics: template.metrics.map((metric) => ({
      key: metric.key,
      keySlug: metric.keySlug,
      defaultUnit: metric.defaultUnit,
      value: "",
      mandatory: metric.mandatory
    })),
  })) || []

  // console.log(savedDataFormatted, initialCategories, "ffff")

  const combineArrays = (array1, array2) => {
    const combined = [...array1]; // Start with Array1

    array2.forEach((category2) => {
      // Find the matching category in Array1
      const category1 = combined.find(
        (category1) => category1.categoryName === category2.categoryName
      );

      if (category1) {
        // Merge unique metrics into the existing category
        const existingKeySlugs = new Set(
          category1.metrics.map((metric) => metric.keySlug)
        );

        const uniqueMetrics = category2.metrics.filter(
          (metric) => !existingKeySlugs.has(metric.keySlug)
        );

        category1.metrics.push(...uniqueMetrics);
      } else {
        // If the category doesn't exist, add it to the combined array
        combined.push(category2);
      }
    });
    return combined;
  };

  const formik = useFormik({
    initialValues: {
      // categories: configurationData.map((template) => ({
      //   categoryName: template.categoryName,
      //   metrics: template.metrics.map((metric) => ({
      //     key: metric.key,
      //     keySlug: metric.keySlug,
      //     defaultUnit: metric.defaultUnit,
      //     value: "",
      //     mandatory: metric.mandatory
      //   })),
      // })),
      categories:
        savedConfigurationData?.data?.length > 0 ? combineArrays(savedDataFormatted, initialCategories) :
          initialCategories,
      selected_template: [],
      currency_type: savedConfigurationData?.data?.length > 0 ? String([...new Set(savedConfigurationData?.data?.filter(item => !["Months", "Count", "Percentage"].includes(item?.unit)).map(item => item?.unit))])
        : 'INR',
      custom_template_name: "",
      custom_template_type: "select_template_type"
    },

    validationSchema: validationSchema,
    enableReinitialize: false,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    onSubmit: (values, { setSubmitting }) => {
      let request = {
        startup_id: startup_id,
        configuredMetrics: values.selected_template?.map(item => {

          return {
            keySlug: item.keySlug,
            unit: item.unit,
            customField: item.customField,
            key: item.key,
            categoryName: item.category,
            display_order: item?.display_order
          }
        })
      }
      handleSubmit(request);
    },
  });

  // useEffect(() => {
  //   if (configurationData != null && savedConfigurationData?.data?.length > 0) {
  //     let selected = []
  //     configurationData.forEach(category => {
  //       category.metrics.forEach(metric => {
  //         savedConfigurationData?.data?.forEach(element => {
  //           if (element.customField == true) {
  //             if (selected.findIndex(item => { return item.keySlug == element.keySlug }) < 0) {
  //               if (category.categoryName == element.categoryName) {
  //                 category.metrics.push({
  //                   key: element.key,
  //                   keySlug: element.keySlug,
  //                   defaultUnit: element.unit,
  //                   value: "",
  //                   type: "custom",
  //                   category: element.categoryName
  //                 })
  //                 selected.push({ key: element.key, keySlug: element.keySlug, unit: element.unit, customField: true, category: element.categoryName })
  //               }
  //             }
  //           }
  //         });
  //         if (savedConfigurationData?.data?.findIndex(item => { return item.keySlug == metric.keySlug }) > -1) {
  //           selected.push({ key: metric.key, keySlug: metric.keySlug, unit: metric.defaultUnit == 'Currency' ? formik.values.currency_type : metric.defaultUnit, customField: false, category: category.categoryName })
  //         }
  //       });
  //     });
  //     // savedConfigurationData[0]?.configuredMetrics.forEach(element => {
  //     //   if (element.customField == true) {
  //     //     categories.${ catIndex }.metrics.push({
  //     //       key: element.key,
  //     //       keySlug: element.keySlug,
  //     //       defaultUnit: element.unit,
  //     //       value: "",
  //     //       type: "custom"
  //     //     })
  //     //     selected.push({ key: element.key, keySlug: element.keySlug, unit: element.unit, customField: true })
  //     //   }
  //     // });
  //     formik.setFieldValue("selected_template", [...new Set([...formik.values.selected_template, ...selected])])
  //   }
  // }, [configurationData, savedConfigurationData])

  // // console.log(savedConfigurationData,"savedConfigurationData")

  // useEffect(() => {
  //   // console.log(configurationData, 'configurationData', savedConfigurationData, "savedConfigurationData")
  //   if (configurationData != null && savedConfigurationData?.data.length == 0) {
  //     let selected = formik?.values?.selected_template
  //     configurationData.forEach(category => {
  //       // console.log(category,"category")
  //       category.metrics.forEach(metric => {
  //         if (metric.mandatory == "true") {
  //           if (selected.findIndex(item => item.keySlug == metric.keySlug) < 0) {
  //             // console.log("metric.key", metric)
  //             selected.push({ key: metric.key, keySlug: metric.keySlug, unit: metric.defaultUnit == 'Currency' ? formik.values.currency_type : metric.defaultUnit, customField: false, category: category.categoryName })
  //           }
  //         }
  //       });
  //     });
  //     formik.setFieldValue("selected_template", [...new Set([...formik.values.selected_template, ...selected])])
  //   }
  // }, [configurationData, formik?.values?.currency_type, savedConfigurationData])

  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const initializeFormValues = () => {
      let selected = [];

      if (savedConfigurationData?.data?.length > 0) {
        // Populate based on savedConfigurationData
        configurationData.forEach((category) => {
          category.metrics.forEach((metric) => {
            if (
              savedConfigurationData?.data?.some(
                (item) => item.keySlug === metric.keySlug
              )
            ) {
              selected.push({
                key: metric.key,
                keySlug: metric.keySlug,
                unit:
                  metric.defaultUnit === "Currency"
                    ? formik.values.currency_type
                    : metric.defaultUnit,
                customField: false,
                category: category.categoryName,
                display_order: metric?.display_order || selected?.length + 1
              });
            }
          });

          // Add custom fields from savedConfigurationData
          savedConfigurationData?.data?.forEach((element, index) => {
            if (element.categoryName === category.categoryName) {
              if (!category.metrics.some((item) => item.keySlug === element.keySlug)) {
                category.metrics.push({
                  key: element.key,
                  keySlug: element.keySlug,
                  defaultUnit: element.unit,
                  value: "",
                  type: "custom",
                  category: element.categoryName,
                  display_order: element?.display_order || index + 1,
                });
              }
              if (!selected.some((item) => item.keySlug === element.keySlug)) {
                selected.push({
                  key: element.key,
                  keySlug: element.keySlug,
                  unit: element.unit,
                  customField: true,
                  category: element.categoryName,
                  display_order: element?.display_order || index + 1,
                });
              }
            }
          });
        });
      } else {
        // Fallback to configurationData if no savedConfigurationData
        configurationData.forEach((category) => {
          category.metrics.forEach((metric) => {
            if (metric.mandatory === "true") {
              selected.push({
                key: metric.key,
                keySlug: metric.keySlug,
                unit:
                  metric.defaultUnit === "Currency"
                    ? formik.values.currency_type
                    : metric.defaultUnit,
                customField: false,
                category: category.categoryName,
                display_order: metric?.display_order || selected?.length + 1
              });
            }
          });
        });
      }

      // Deduplicate and set form values
      const uniqueSelectedTemplate = [
        ...new Map(
          [...formik.values.selected_template, ...selected].map((item) => [
            item.keySlug,
            item,
          ])
        ).values(),
      ];

      formik.setFieldValue("selected_template", uniqueSelectedTemplate);
    };

    initializeFormValues();
  }, [configurationData, savedConfigurationData, formik.values.currency_type, isLoading]);

  // console.log([...new Set(savedConfigurationData?.data?.filter(item => !["Months", "Count", "Percentage"].includes(item?.unit)).map(item => item?.unit))]
  // ,"ddd")

  return (
    <Paper
      sx={{
        background: theme.palette.customColors.whiteBG,
        borderRadius: "8px",
      }}
    >
      <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }}>
        <CloseIcon width={40} height={40} onClick={handleClose} />
      </IconButton>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <Grid display={"grid"} container padding={"1.5rem"}>
            <Grid item xs={12} mb={'1.5rem'}>
              <Typography
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 700,
                  lineHeight: "28px",
                  color: theme.palette.customColors.g300,
                }}
              >
                Add Metrics
              </Typography>
            </Grid>
            <Grid display={'flex'} alignItems={'center'} gap={2} mb={'1rem'}>
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 700,
                  lineHeight: "1rem",
                  color: theme.palette.customColors.g300,
                }}
              >
                Select Currency
              </Typography>
              <Grid
                item
              >
                <Select
                  size="small"
                  name={'currency_type'}
                  fullWidth
                  value={formik.values.currency_type}
                  onChange={(e) => {
                    formik.setFieldValue(
                      `currency_type`,
                      e.target.value
                    )
                  }
                  }
                  sx={{
                    background: theme.palette.customColors.whiteBG,
                    // paddingBlock: "6px",
                  }}
                >
                  <MenuItem value="select_currency_type" disabled>
                    Select currency type
                  </MenuItem>
                  {[{ label: "INR", value: "INR" }, { label: "USD", value: "USD" }]?.map(item => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>
                  })}
                </Select>
              </Grid>
              {formik.errors.currency_type && formik.touched.currency_type && (
                <CustomValidationText value={formik.errors.currency_type} />
              )}
            </Grid>
            <Divider />
            <PerfectScrollbar containerRef={containerRef} style={{ height: "calc(100vh - 355px)" }}>
              {/* {console.log("categories", formik.values?.categories,formik.values?.selected_template)} */}
              <Grid>
                <FieldArray name="categories">
                  {
                    () =>
                      formik.values.categories.map((category, catIndex) => {
                        return (
                          <>

                            <Box display="flex" width={"100%"} justifyContent={"space-between"}>
                              <Typography
                                sx={{
                                  fontSize: "1rem",
                                  fontWeight: 700,
                                  lineHeight: "1rem",
                                  color: theme.palette.customColors.g300,
                                  marginTop: '1rem',
                                  marginBottom: "1rem"
                                }}
                              >
                                {category.categoryName}
                              </Typography>
                              <WHITEBG
                                startIcon={<AddIcon style={{ stroke: "#7c4dff !important" }} />}
                                disableRipple
                                sx={{
                                  borderRadius: '8px',
                                  borderWidth: '0px',
                                  // padding: '10px 20px 10px 20px',
                                  marginBottom: 0,
                                  // marginTop: "-0.5rem",
                                  borderColor: theme?.palette?.customColors?.g100,
                                  color: "#7c4dff",
                                  fontWeight: 700,
                                }}
                                onClick={() => {
                                  // helper.insert(index + 1, {
                                  //   name: '',
                                  //   percentage: 0,
                                  // });
                                  setSelectedCategory(category?.categoryName)
                                  // setSelectedCategory(category[catIndex]?.categoryName)
                                  setShowCustomTemplate(true)
                                }
                                }
                              >
                                Add more
                              </WHITEBG>
                            </Box>

                            <Box>
                              <FieldArray name={`categories.${catIndex}.metrics`}
                                render={({ push, remove }) => {
                                  return <>
                                    <Grid display={'grid'} gap={2} xs={12}
                                      position={"relative"} className="draggable-containerrr"
                                      // gridTemplateColumns={{ xs: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }} 
                                      pb={2}>
                                      {
                                        category.metrics?.map((metric, metricIndex) => {
                                          let label = metric.key
                                          if (metric.defaultUnit == 'Currency' || metric.defaultUnit == 'USD' || metric.defaultUnit == 'INR') {
                                            if (formik.values.currency_type != 'select_currency_type') {
                                              label = label + " (" + formik.values.currency_type + ")"
                                            }
                                          } else if (metric.defaultUnit == 'Months') {
                                            label = label + " (Months)"
                                          } else if (metric.defaultUnit == 'Percentage') {
                                            label = label + " (%)"
                                          }
                                          return (
                                            <>

                                              <Grid
                                                display={'flex'} alignItems={'normal'}
                                                sx={{
                                                  left: "auto !important",
                                                  position: "static !important"
                                                }}
                                              >
                                                <FormGroup
                                                  name={`categories.${catIndex}.metrics.${metricIndex}.value`}
                                                >
                                                  <Grid display={"flex"}
                                                    // border={savedConfigurationData?.data?.length > 0 ? "1px solid #7c4dff" : "0px solid"}
                                                    sx={{
                                                      paddingTop: "0.5rem", paddingInline: "0.5rem", borderRadius: "4px",
                                                      bgcolor: "white"
                                                    }} >
                                                    {/* {savedConfigurationData?.data?.length > 0 && <Menu sx={{ marginRight: '1rem' }} />} */}
                                                    <FormControlLabel
                                                      value={metric.keySlug}
                                                      control={<Checkbox
                                                        checked={metric.mandatory == 'true' || metric.type == 'custom' || metric.customField == true ? true : formik.values?.selected_template.findIndex(item => item.keySlug == metric.keySlug) > -1}
                                                        onChange={(e) => {
                                                          if (metric.mandatory == 'true' || metric.type == 'custom' || metric.customField == true) {
                                                            e.preventDefault()
                                                          } else {
                                                            let updatedTemplates = formik.values?.selected_template
                                                            if (updatedTemplates.findIndex(item => item.keySlug == metric.keySlug) > -1) {
                                                              updatedTemplates = updatedTemplates.filter(template => template.keySlug !== metric.keySlug)
                                                            } else {
                                                              updatedTemplates.push({ key: metric.key, keySlug: metric.keySlug, unit: metric.defaultUnit == 'Currency' ? formik.values.currency_type : metric.defaultUnit, customField: false, category: category.categoryName })
                                                            }
                                                            formik.setFieldValue(
                                                              `selected_template`,
                                                              updatedTemplates
                                                            )
                                                          }
                                                        }
                                                        } style={{ color: "#7c4dff", paddingTop: '0rem' }} disableRipple />}
                                                      label={label}
                                                      sx={{ alignItems: "flex-start" }}
                                                    />
                                                    {
                                                      (metric.type == 'custom' || metric.customField == true) && <Grid>
                                                        <Secondary
                                                          sx={{
                                                            padding: 0,
                                                            minWidth: 0,
                                                            background:
                                                              "transparent",
                                                            border: "transparent",
                                                            marginLeft: "0.5rem"
                                                          }}
                                                          onClick={() => {
                                                            remove(
                                                              metricIndex
                                                            );
                                                            // console.log(metric?.keySlug,"metric")
                                                            formik.setFieldValue("selected_template", formik.values?.selected_template?.filter(item => item?.keySlug !== metric?.keySlug))
                                                          }
                                                          }
                                                        >
                                                          <DeleteIcon color="#F94F4F" width={'1rem'} />
                                                        </Secondary>
                                                      </Grid>
                                                    }
                                                  </Grid>

                                                </FormGroup>

                                              </Grid>
                                            </>
                                          )
                                        })
                                      }
                                    </Grid>
                                    {/* {console.log(showCustomTemplate, category?.categoryName, showCustomTemplate && selectedCategory == category?.categoryName, selectedCategory)} */}
                                    <ModalComponent open={showCustomTemplate && selectedCategory == category?.categoryName} onClose={() => {
                                      setSelectedCategory(null);
                                      setShowCustomTemplate(false);
                                    }} style={{ maxWidth: 400 }}>

                                      <Paper sx={{
                                        padding: '1rem',
                                        background: theme.palette.customColors.whiteBG,
                                        borderRadius: "8px",
                                      }}>
                                        <IconButton sx={{ position: "absolute", top: 10, right: 20, padding: 0 }}>
                                          <CloseIcon width={40} height={40} onClick={() => {
                                            setSelectedCategory(null);
                                            setShowCustomTemplate(false);
                                          }} />
                                        </IconButton>
                                        <Grid container xs={12} display={"grid"}>
                                          <Grid item xs={12}>
                                            <Typography
                                              sx={{
                                                fontSize: "1.5rem",
                                                fontWeight: 700,
                                                lineHeight: "28px",
                                                color: theme.palette.customColors.g300,
                                              }}
                                            >
                                              Add Custom Metric
                                            </Typography>
                                          </Grid>
                                          {/* <Grid mb={"1rem"}> */}
                                          <Grid
                                            item
                                            container
                                            xs={12}
                                            display={"flex"}
                                            spacing={"0.5rem"}
                                            mt={'1rem'}
                                          >
                                            <Grid
                                              item
                                              xs={12}
                                            // sm={4}
                                            // lg={4}
                                            >
                                              <CustomInputField
                                                sx={{
                                                  borderRadius:
                                                    "4px",
                                                  marginBottom: 0,
                                                }}
                                                name={`custom_template_name`}
                                                placeholder={'Metric name'}
                                                value={
                                                  formik.values.custom_template_name
                                                }
                                                onChange={(e) =>
                                                  formik.setFieldValue("custom_template_name", e.target.value)
                                                }
                                                fullWidth={true}
                                              />
                                              {formik.errors.custom_template_name && formik.touched.custom_template_name && (
                                                <CustomValidationText value={formik.errors.custom_template_name} style={{ marginLeft: 0 }} />
                                              )}
                                            </Grid>
                                            <Grid
                                              item
                                              xs={12}
                                            // sm={4}
                                            // lg={4}
                                            >
                                              <Select
                                                size="small"
                                                name={'custom_template_type'}
                                                fullWidth
                                                value={formik.values.custom_template_type}
                                                onChange={(e) => {
                                                  formik.setFieldValue("custom_template_type", e.target.value)
                                                }
                                                }
                                                sx={{
                                                  background: theme.palette.customColors.whiteBG,
                                                  paddingBlock: "6px",
                                                }}
                                              >
                                                <MenuItem value="select_template_type" disabled>
                                                  Select Metric type
                                                </MenuItem>
                                                {[{ label: "Currency", value: "Currency" }, { label: "Months", value: "Months" }, { label: "Percentage", value: "Percentage" }, { label: "Count", value: "Count" }]?.map(item => {
                                                  return <MenuItem value={item.value}>{item.label}</MenuItem>
                                                })}
                                              </Select>
                                              {formik.errors.custom_template_type && formik.touched.custom_template_type && (
                                                <CustomValidationText value={formik.errors.custom_template_type} style={{ marginLeft: 0 }} />
                                              )}
                                            </Grid>
                                            <Grid item
                                              xs={12}
                                              marginTop={1}
                                              display={"flex"}
                                              gap={2}
                                            // sm={4}
                                            // lg={4}
                                            >
                                              <Secondary
                                                fullWidth
                                                onClick={() => {
                                                  setSelectedCategory(null);
                                                  setShowCustomTemplate(false);
                                                }}
                                                sx={{ borderWidth: 1, padding: "0.75rem 1.25rem", fontSize: "1rem" }}
                                              >
                                                Close
                                              </Secondary>
                                              <Primary
                                                type="button"
                                                fullWidth
                                                sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
                                                onClick={() => {
                                                  if (formik.values.custom_template_name?.trim()?.length > 0) {
                                                    formik.setFieldError('custom_template_name', null)
                                                    formik.setFieldTouched('custom_template_name', false)
                                                    if (formik.values.custom_template_type?.trim()?.length > 0) {
                                                      if (formik.values.custom_template_type != "select_template_type") {
                                                        formik.setFieldError('custom_template_type', null)
                                                        formik.setFieldTouched('custom_template_type', false)
                                                        push({
                                                          key: capitalizedSentence(formik.values.custom_template_name),
                                                          keySlug: formik.values.custom_template_name.toLowerCase().replace(/ /g, "_"),
                                                          defaultUnit: formik.values.custom_template_type,
                                                          value: "",
                                                          type: "custom"
                                                        })
                                                        formik.values?.selected_template.push({ key: capitalizedSentence(formik.values.custom_template_name), keySlug: formik.values.custom_template_name.toLowerCase().replace(/ /g, "_"), unit: formik.values.custom_template_type == 'Currency' ? formik.values.currency_type : formik.values.custom_template_type, customField: true, category: category.categoryName })
                                                        formik.setFieldValue("custom_template_name", "")
                                                        formik.setFieldValue("custom_template_type", "select_template_type")
                                                        setShowCustomTemplate(false)
                                                      } else {
                                                        formik.setFieldError('custom_template_type', "Key type is required")
                                                        formik.setFieldTouched('custom_template_type', true)
                                                      }
                                                    } else {
                                                      formik.setFieldError('custom_template_type', "Key type is required")
                                                      formik.setFieldTouched('custom_template_type', true)
                                                    }
                                                  } else {
                                                    formik.setFieldError('custom_template_name', "Key name is required")
                                                    formik.setFieldTouched('custom_template_name', true)
                                                  }
                                                }}
                                              >
                                                Add
                                              </Primary>
                                            </Grid>
                                          </Grid>
                                          {/* </Grid> */}
                                        </Grid>
                                      </Paper>

                                    </ModalComponent>


                                  </>
                                }}

                              />
                            </Box>

                            <Divider />
                          </>)
                      }
                      )}

                </FieldArray>
                {formik.errors.selected_template && formik.touched.selected_template && (
                  <CustomValidationText value={formik.errors.selected_template} style={{ marginLeft: 0 }} />
                )}
              </Grid>
            </PerfectScrollbar>
            <Grid item xs={12} mt={'1.5rem'} padding={"0 1.5rem"} display={'flex'} justifyContent={'center'}>
              <Primary
                type="submit"
                onClick={(e) => {
                  handleFormSubmit(e, formik);
                }}
                sx={{ padding: "0.75rem 1.25rem", fontSize: "1rem" }}
              >
                Submit
              </Primary>
            </Grid>
          </Grid>
        </form>
      </FormikProvider>
    </Paper>
  );
};

export default SetConfigurationsPopup;